// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
export default {
   "AD": {
     "fixedline": "712345",
     "mobile": "312345",
     "tollfree": "18001234"
   },
   "AE": {
     "fixed": "22345678",
     "mobile": "501234567",
     "tollfree": "800123456"
   },
   "AF": {
     "fixedline": "234567890",
     "mobile": "701234567"
   },
   "AL": {
     "fixedline": "22345678",
     "mobile": "672123456",
     "tollfree": "8001234"
   },
   "AM": {
     "fixedline": "10123456",
     "mobile": "77123456",
     "tollfree": "80012345"
   },
   "AO": {
     "fixedline": "222123456",
     "mobile": "923123456"
   },
   "AR": {
     "fixedline": "1123456789",
     "mobile": "91123456789",
     "tollfree": "8001234567"
   },
   "AT": {
     "fixed": "1234567890",
     "mobile": "664123456",
     "tollfree": "800123456"
   },
   "AU": {
     "fixed": "212345678",
     "mobile": "412345678",
     "tollfree": "1800123456"
   },
   "AW": {
     "fixedline": "5212345",
     "mobile": "5601234",
     "tollfree": "8001234"
   },
   "AZ": {
     "fixedline": "123123456",
     "mobile": "401234567",
     "tollfree": "881234567"
   },
   "BA": {
     "fixedline": "30212345",
     "mobile": "61123456",
     "tollfree": "80123456"
   },
   "BD": {
     "fixedline": "27111234",
     "mobile": "1812345678",
     "tollfree": "8001234567"
   },
   "BE": {
     "fixed": "12345678",
     "mobile": "470123456",
     "tollfree": "80012345"
   },
   "BF": {
     "fixedline": "20491234",
     "mobile": "70123456"
   },
   "BG": {
     "fixedline": "2123456",
     "mobile": "48123456",
     "tollfree": "80012345"
   },
   "BH": {
     "fixedline": "17001234",
     "mobile": "36001234",
     "tollfree": "80123456"
   },
   "BI": {
     "fixedline": "22201234",
     "mobile": "79561234"
   },
   "BJ": {
     "fixedline": "20211234",
     "mobile": "90011234"
   },
   "BN": {
     "fixedline": "2345678",
     "mobile": "7123456"
   },
   "BO": {
     "fixedline": "22123456",
     "mobile": "71234567",
     "tollfree": "800171234"
   },
   "BR": {
     "fixedline": "1123456789",
     "mobile": "11961234567",
     "tollfree": "800123456"
   },
   "BT": {
     "fixedline": "2345678",
     "mobile": "17123456"
   },
   "BW": {
     "fixedline": "2401234",
     "mobile": "71123456",
     "tollfree": "0800012345"
   },
   "BY": {
     "fixedline": "152450911",
     "mobile": "294911911",
     "tollfree": "8011234567"
   },
   "BZ": {
     "fixedline": "2221234",
     "mobile": "6221234",
     "tollfree": "08001234123"
   },
   "CA": {
     "fixed": "5062345678",
     "mobile": "5062345678",
     "tollfree": "8002123456"
   },
   "CD": {
     "fixedline": "1234567",
     "mobile": "991234567"
   },
   "CF": {
     "fixedline": "21612345",
     "mobile": "70012345"
   },
   "CG": {
     "fixedline": "222123456",
     "mobile": "061234567"
   },
   "CH": {
     "fixed": "212345678",
     "mobile": "781234567",
     "tollfree": "800123456"
   },
   "CI": {
     "fixedline": "2123456789",
     "mobile": "0123456789"
   },
   "CK": {
     "fixedline": "21234",
     "mobile": "71234"
   },
   "CL": {
     "fixedline": "221234567",
     "mobile": "221234567",
     "tollfree": "800123456"
   },
   "CM": {
     "fixedline": "222123456",
     "mobile": "671234567",
     "tollfree": "88012345"
   },
   "CN": {
     "fixed": "1012345678",
     "mobile": "13123456789",
     "tollfree": "8001234567"
   },
   "CO": {
     "fixedline": "12345678",
     "mobile": "3211234567",
     "tollfree": "18001234567"
   },
   "CR": {
     "fixedline": "22123456",
     "mobile": "83123456",
     "tollfree": "8001234567"
   },
   "CU": {
     "fixedline": "71234567",
     "mobile": "51234567",
     "tollfree": "8001234567"
   },
   "CV": {
     "fixedline": "2211234",
     "mobile": "9911234",
     "tollfree": "8001234"
   },
   "CW": {
     "fixedline": "94351234",
     "mobile": "95181234"
   },
   "CY": {
     "fixedline": "22345678",
     "mobile": "96123456",
     "tollfree": "80001234"
   },
   "CZ": {
     "fixed": "212345678",
     "mobile": "601123456",
     "tollfree": "800123456"
   },
   "DE": {
     "fixed": "30123456",
     "mobile": "15123456789",
     "tollfree": "8001234567890"
   },
   "DJ": {
     "fixedline": "21360003",
     "mobile": "77831001"
   },
   "DK": {
     "fixed": "32123456",
     "mobile": "32123456",
     "tollfree": "80123456"
   },
   "DZ": {
     "fixedline": "12345678",
     "mobile": "551234567",
     "tollfree": "800123456"
   },
   "EC": {
     "fixedline": "22123456",
     "mobile": "991234567",
     "tollfree": "18001234567"
   },
   "EE": {
     "fixed": "3212345",
     "mobile": "51234567",
     "tollfree": "80012345"
   },
   "EG": {
     "fixedline": "234567890",
     "mobile": "1001234567",
     "tollfree": "8001234567"
   },
   "ER": {
     "fixedline": "8370362",
     "mobile": "7123456"
   },
   "ES": {
     "fixed": "810123456",
     "mobile": "612345678",
     "tollfree": "800123456"
   },
   "ET": {
     "fixedline": "111112345",
     "mobile": "911234567"
   },
   "FI": {
     "fixed": "131234567",
     "mobile": "412345678",
     "tollfree": "800123456"
   },
   "FJ": {
     "fixedline": "3212345",
     "mobile": "7012345",
     "tollfree": "08001234567"
   },
   "FM": {
     "fixedline": "3201234",
     "mobile": "3501234"
   },
   "FO": {
     "fixedline": "201234",
     "mobile": "211234",
     "tollfree": "802123"
   },
   "FR": {
     "fixed": "123456789",
     "mobile": "612345678",
     "tollfree": "801234567"
   },
   "GA": {
     "fixedline": "01441234",
     "mobile": "06031234"
   },
   "GB": {
     "fixed": "2012345678",
     "mobile": "7400123456",
     "tollfree": "8001234567"
   },
   "GE": {
     "fixedline": "322123456",
     "mobile": "555123456",
     "tollfree": "800123456"
   },
   "GF": {
     "fixedline": "594101234",
     "mobile": "694201234",
     "tollfree": "800012345"
   },
   "GH": {
     "fixedline": "302345678",
     "mobile": "231234567",
     "tollfree": "80012345"
   },
   "GI": {
     "fixedline": "20012345",
     "mobile": "57123456"
   },
   "GL": {
     "fixedline": "321000",
     "mobile": "221234",
     "tollfree": "801234"
   },
   "GM": {
     "fixedline": "5661234",
     "mobile": "3012345"
   },
   "GN": {
     "fixedline": "30241234",
     "mobile": "601123456"
   },
   "GP": {
     "fixedline": "590201234",
     "mobile": "690001234",
     "tollfree": "800012345"
   },
   "GQ": {
     "fixedline": "333091234",
     "mobile": "222123456",
     "tollfree": "800123456"
   },
   "GR": {
     "fixed": "2123456789",
     "mobile": "6912345678",
     "tollfree": "8001234567"
   },
   "GT": {
     "fixedline": "22456789",
     "mobile": "51234567",
     "tollfree": "18001112222"
   },
   "GW": {
     "fixedline": "443201234",
     "mobile": "955012345"
   },
   "GY": {
     "fixedline": "2201234",
     "mobile": "6091234",
     "tollfree": "2891234"
   },
   "HK": {
     "fixed": "21234567",
     "mobile": "51234567",
     "tollfree": "800123456"
   },
   "HN": {
     "fixedline": "22123456",
     "mobile": "91234567",
     "tollfree": "80021234567"
   },
   "HR": {
     "fixed": "12345678",
     "mobile": "921234567",
     "tollfree": "800123456"
   },
   "HT": {
     "fixedline": "22453300",
     "mobile": "34101234",
     "tollfree": "80012345"
   },
   "HU": {
     "fixed": "12345678",
     "mobile": "201234567",
     "tollfree": "80123456"
   },
   "ID": {
     "fixedline": "218350123",
     "mobile": "812345678",
     "tollfree": "8001234567"
   },
   "IE": {
     "fixed": "2212345",
     "mobile": "850123456",
     "tollfree": "1800123456"
   },
   "IL": {
     "fixed": "21234567",
     "mobile": "502345678",
     "tollfree": "1800123456"
   },
   "IN": {
     "fixed": "7410410123",
     "mobile": "8123456789",
     "tollfree": "1800123456"
   },
   "IO": {
     "fixedline": "3709100",
     "mobile": "3801234"
   },
   "IQ": {
     "fixedline": "12345678",
     "mobile": "7912345678"
   },
   "IR": {
     "fixedline": "2123456789",
     "mobile": "9123456789"
   },
   "IS": {
     "fixed": "4101234",
     "mobile": "6111234",
     "tollfree": "8001234"
   },
   "IT": {
     "fixed": "0212345678",
     "mobile": "3123456789",
     "tollfree": "800123456"
   },
   "JO": {
     "fixed": "62001234",
     "mobile": "790123456",
     "tollfree": "80012345"
   },
   "JP": {
     "fixed": "312345678",
     "mobile": "9012345678",
     "tollfree": "120123456"
   },
   "KE": {
     "fixedline": "202012345",
     "mobile": "712123456",
     "tollfree": "800223456"
   },
   "KG": {
     "fixedline": "312123456",
     "mobile": "700123456",
     "tollfree": "800123456"
   },
   "KH": {
     "fixedline": "23756789",
     "mobile": "91234567",
     "tollfree": "1800123456"
   },
   "KM": {
     "fixedline": "7712345",
     "mobile": "3212345"
   },
   "KP": {
     "fixedline": "21234567",
     "mobile": "1921234567"
   },
   "KR": {
     "fixed": "22123456",
     "mobile": "1020000000",
     "tollfree": "801234567"
   },
   "KW": {
     "fixedline": "22345678",
     "mobile": "50012345",
     "tollfree": "1801234"
   },
   "LA": {
     "fixedline": "21212862",
     "mobile": "2023123456"
   },
   "LB": {
     "fixedline": "1123456",
     "mobile": "71123456"
   },
   "LI": {
     "fixedline": "2345678",
     "mobile": "660234567",
     "tollfree": "8002222"
   },
   "LK": {
     "fixedline": "112345678",
     "mobile": "712345678"
   },
   "LR": {
     "fixedline": "21234567",
     "mobile": "770123456"
   },
   "LS": {
     "fixedline": "22123456",
     "mobile": "50123456",
     "tollfree": "80021234"
   },
   "LT": {
     "fixed": "31234567",
     "mobile": "61234567",
     "tollfree": "80012345"
   },
   "LU": {
     "fixed": "27123456",
     "mobile": "628123456",
     "tollfree": "80012345"
   },
   "LV": {
     "fixed": "63123456",
     "mobile": "21234567",
     "tollfree": "80123456"
   },
   "LY": {
     "fixedline": "212345678",
     "mobile": "912345678"
   },
   "MA": {
     "fixedline": "520123456",
     "mobile": "650123456",
     "tollfree": "801234567"
   },
   "MC": {
     "fixedline": "99123456",
     "mobile": "612345678",
     "tollfree": "90123456"
   },
   "MD": {
     "fixedline": "22212345",
     "mobile": "62112345",
     "tollfree": "80012345"
   },
   "ME": {
     "fixedline": "30234567",
     "mobile": "67622901",
     "tollfree": "80080002"
   },
   "MG": {
     "fixedline": "202123456",
     "mobile": "321234567"
   },
   "MH": {
     "fixedline": "2471234",
     "mobile": "2351234"
   },
   "MK": {
     "fixedline": "22012345",
     "mobile": "72345678",
     "tollfree": "80012345"
   },
   "ML": {
     "fixedline": "20212345",
     "mobile": "65012345",
     "tollfree": "80012345"
   },
   "MM": {
     "fixedline": "1234567",
     "mobile": "92123456",
     "tollfree": "8008001234"
   },
   "MN": {
     "fixedline": "53123456",
     "mobile": "88123456"
   },
   "MO": {
     "fixed": "28212345",
     "mobile": "66123456",
     "tollfree": "undefined"
   },
   "MQ": {
     "fixedline": "596301234",
     "mobile": "696201234",
     "tollfree": "800012345"
   },
   "MR": {
     "fixedline": "35123456",
     "mobile": "22123456",
     "tollfree": "80012345"
   },
   "MT": {
     "fixedline": "21001234",
     "mobile": "96961234",
     "tollfree": "80071234"
   },
   "MU": {
     "fixedline": "54480123",
     "mobile": "52512345",
     "tollfree": "8001234"
   },
   "MV": {
     "fixedline": "6701234",
     "mobile": "7712345",
     "tollfree": "8001234567"
   },
   "MW": {
     "fixedline": "1234567",
     "mobile": "991234567"
   },
   "MX": {
     "fixed": "2001234567",
     "mobile": "12221234567",
     "tollfree": "8001234567"
   },
   "MY": {
     "fixedline": "323856789",
     "mobile": "123456789",
     "tollfree": "1300123456"
   },
   "MZ": {
     "fixedline": "21123456",
     "mobile": "821234567",
     "tollfree": "800123456"
   },
   "NA": {
     "fixedline": "61221234",
     "mobile": "811234567",
     "tollfree": "800123456"
   },
   "NC": {
     "fixedline": "201234",
     "mobile": "751234"
   },
   "NE": {
     "fixedline": "20201234",
     "mobile": "93123456",
     "tollfree": "08123456"
   },
   "NF": {
     "fixedline": "106609",
     "mobile": "381234"
   },
   "NG": {
     "fixedline": "18040123",
     "mobile": "8021234567",
     "tollfree": "80017591759"
   },
   "NI": {
     "fixedline": "21234567",
     "mobile": "81234567",
     "tollfree": "18001234"
   },
   "NL": {
     "fixed": "101234567",
     "mobile": "612345678",
     "tollfree": "8001234"
   },
   "NO": {
     "fixed": "21234567",
     "mobile": "40612345",
     "tollfree": "80012345"
   },
   "NP": {
     "fixedline": "14567890",
     "mobile": "9841234567",
     "tollfree": "16600101234"
   },
   "NR": {
     "fixedline": "4441234",
     "mobile": "5551234"
   },
   "NU": {
     "fixedline": "7012",
     "mobile": "8884012"
   },
   "NZ": {
     "fixed": "32345678",
     "mobile": "211234567",
     "tollfree": "800123456"
   },
   "OM": {
     "fixedline": "23123456",
     "mobile": "92123456",
     "tollfree": "80071234"
   },
   "PA": {
     "fixedline": "2001234",
     "mobile": "61234567",
     "tollfree": "8001234"
   },
   "PE": {
     "fixedline": "11234567",
     "mobile": "912345678",
     "tollfree": "80012345"
   },
   "PF": {
     "fixedline": "40412345",
     "mobile": "87123456",
     "tollfree": "800012345"
   },
   "PG": {
     "fixedline": "3123456",
     "mobile": "70123456",
     "tollfree": "1801234"
   },
   "PH": {
     "fixedline": "232345678",
     "mobile": "9051234567",
     "tollfree": "180012345678"
   },
   "PK": {
     "fixedline": "2123456789",
     "mobile": "3012345678",
     "tollfree": "80012345"
   },
   "PL": {
     "fixed": "123456789",
     "mobile": "512345678",
     "tollfree": "800123456"
   },
   "PM": {
     "fixedline": "430123",
     "mobile": "551234",
     "tollfree": "800012345"
   },
   "PR": {
     "fixed": "7872345678",
     "mobile": "7872345678",
     "tollfree": "8002345678"
   },
   "PS": {
     "fixedline": "22234567",
     "mobile": "599123456",
     "tollfree": "1800123456"
   },
   "PT": {
     "fixed": "212345678",
     "mobile": "912345678",
     "tollfree": "800123456"
   },
   "PW": {
     "fixedline": "2771234",
     "mobile": "6201234"
   },
   "PY": {
     "fixedline": "212345678",
     "mobile": "961456789",
     "tollfree": "98000123456"
   },
   "QA": {
     "fixedline": "44123456",
     "mobile": "33123456",
     "tollfree": "8001234"
   },
   "RE": {
     "fixedline": "262161234",
     "mobile": "692123456",
     "tollfree": "801234567"
   },
   "RO": {
     "fixed": "211234567",
     "mobile": "712034567",
     "tollfree": "800123456"
   },
   "RS": {
     "fixedline": "10234567",
     "mobile": "601234567",
     "tollfree": "80012345"
   },
   "RU": {
     "fixedline": "3011234567",
     "mobile": "9123456789",
     "tollfree": "8001234567"
   },
   "RW": {
     "fixedline": "250123456",
     "mobile": "720123456",
     "tollfree": "800123456"
   },
   "SA": {
     "fixedline": "112345678",
     "mobile": "512345678",
     "tollfree": "8001234567"
   },
   "SB": {
     "fixedline": "40123",
     "mobile": "7421234",
     "tollfree": "18123"
   },
   "SC": {
     "fixedline": "4217123",
     "mobile": "2510123",
     "tollfree": "8000000"
   },
   "SD": {
     "fixedline": "153123456",
     "mobile": "911231234"
   },
   "SE": {
     "fixed": "8123456",
     "mobile": "701234567",
     "tollfree": "20123456"
   },
   "SG": {
     "fixed": "61234567",
     "mobile": "81234567",
     "tollfree": "18001234567"
   },
   "SI": {
     "fixed": "12345678",
     "mobile": "31234567",
     "tollfree": "80123456"
   },
   "SK": {
     "fixed": "221234567",
     "mobile": "912123456",
     "tollfree": "800123456"
   },
   "SL": {
     "fixedline": "22221234",
     "mobile": "25123456"
   },
   "SM": {
     "fixedline": "0549886377",
     "mobile": "66661212"
   },
   "SN": {
     "fixedline": "301012345",
     "mobile": "701234567",
     "tollfree": "800123456"
   },
   "SO": {
     "fixedline": "4012345",
     "mobile": "71123456"
   },
   "SR": {
     "fixedline": "211234",
     "mobile": "7412345"
   },
   "SS": {
     "fixedline": "181234567",
     "mobile": "977123456"
   },
   "ST": {
     "fixedline": "2221234",
     "mobile": "9812345"
   },
   "SV": {
     "fixedline": "21234567",
     "mobile": "70123456",
     "tollfree": "8001234"
   },
   "SY": {
     "fixedline": "112345678",
     "mobile": "944567890"
   },
   "SZ": {
     "fixedline": "22171234",
     "mobile": "76123456",
     "tollfree": "08001234"
   },
   "TD": {
     "fixedline": "22501234",
     "mobile": "63012345"
   },
   "TG": {
     "fixedline": "22212345",
     "mobile": "90112345"
   },
   "TH": {
     "fixedline": "21234567",
     "mobile": "812345678",
     "tollfree": "1800123456"
   },
   "TJ": {
     "fixedline": "372123456",
     "mobile": "917123456"
   },
   "TL": {
     "fixedline": "2112345",
     "mobile": "77212345",
     "tollfree": "8012345"
   },
   "TM": {
     "fixedline": "12345678",
     "mobile": "66123456"
   },
   "TN": {
     "fixedline": "30010123",
     "mobile": "20123456",
     "tollfree": "80101234"
   },
   "TO": {
     "fixedline": "20123",
     "mobile": "7715123",
     "tollfree": "0800222"
   },
   "TR": {
     "tollfree": "8001234567",
     "fixed": "2123456789",
     "mobile": "5012345678"
   },
   "TV": {
     "fixedline": "20123",
     "mobile": "901234"
   },
   "TW": {
     "fixed": "221234567",
     "mobile": "912345678",
     "tollfree": "800123456"
   },
   "TZ": {
     "fixedline": "222345678",
     "mobile": "621234567",
     "tollfree": "800123456"
   },
   "UA": {
     "fixedline": "311234567",
     "mobile": "501234567",
     "tollfree": "800123456"
   },
   "UG": {
     "fixedline": "312345678",
     "mobile": "712345678",
     "tollfree": "800123456"
   },
   "US": {
     "fixed": "2015550123",
     "mobile": "2015550123",
     "tollfree": "8002345678"
   },
   "UY": {
     "fixedline": "21231234",
     "mobile": "94231234",
     "tollfree": "8001234"
   },
   "UZ": {
     "fixedline": "669050123",
     "mobile": "912345678"
   },
   "VE": {
     "fixedline": "2121234567",
     "mobile": "4121234567",
     "tollfree": "8001234567"
   },
   "VN": {
     "fixedline": "2101234567",
     "mobile": "912345678",
     "tollfree": "1800123456"
   },
   "VU": {
     "fixedline": "22123",
     "mobile": "5912345"
   },
   "WF": {
     "fixedline": "721234",
     "mobile": "821234",
     "tollfree": "800012345"
   },
   "WS": {
     "fixedline": "22123",
     "mobile": "7212345",
     "tollfree": "800123"
   },
   "XK": {
     "fixedline": "28012345",
     "mobile": "43201234",
     "tollfree": "80001234"
   },
   "YE": {
     "fixedline": "1234567",
     "mobile": "712345678"
   },
   "ZA": {
     "fixed": "101234567",
     "mobile": "711234567",
     "tollfree": "801234567"
   },
   "ZM": {
     "fixedline": "211234567",
     "mobile": "955123456",
     "tollfree": "800123456"
   },
   "ZW": {
     "fixedline": "1312345",
     "mobile": "712345678",
     "tollfree": "8001234"
   }
 }